import { get, post } from "../api_helper";

const UpdateProfilePicture = async (data) => {
  const url = "update-profile-picture";
  const response = await post(url, data);
  return response;
};

const CreateUser = async (data) => {
  const url = "create-user";
  const response = await post(url, data);
  return response;
};

const UpdateUser = async (data) => {
  const url = "update-user";
  const response = await post(url, data);
  return response;
};

const UpdatePassword = async (data) => {
  const url = "update-password";
  const response = await post(url, data);
  return response;
};

const GetUsersByRole = async (roleID) => {
  const url = "get-users-by-role?roleId=" + roleID;
    const response = await get(url);
    return response;
};

const GetUserById = async (userId) => {
  const url = "get-user-by-id?userId=" + userId;
    const response = await get(url);
    return response;
};

const ChangeUserStatus = async (userId) => {
  const url = "change-user-status-by-id?userId=" + userId;
    const response = await get(url);
    return response;
};

const DeleteUser = async (userId) => {
  const url = "delete-user-by-id?userId=" + userId;
    const response = await get(url);
    return response;
};

export { UpdateProfilePicture, CreateUser, UpdateUser, GetUserById,  GetUsersByRole, ChangeUserStatus, DeleteUser, UpdatePassword };
